import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

export const entityRoute = {
    GET_COMPANIES_TREE: "dashboard/core/company/list/tree",
    GET_COMPANIES_TREE_V1: "dashboard/core/company/v1/list/tree",
    GET_EXPIRED_COMPANIES: "dashboard/core/company/expired",
};
export default {
    /**
     * Versión de listCompanies: árbol solo con empresas vigentes (excluye vencidas y sus hijas).
     * Usar en selectores operativos. La gestión de usuarios sigue con listCompanies para no perder
     * asignaciones a empresas vencidas al guardar.
     * @returns {Promise<Array|null>} null si la consulta falló, para no confundirlo con "sin empresas vigentes"
     */
    listCompaniesV1() {
        return http
            .get(entityRoute.GET_COMPANIES_TREE_V1)
            .then(({data}) => {
                if (data.code < 0) {
                    toast.error("Error al consultar las companías");
                    return null;
                }
                // Lista vacía es válida (todas vencidas): el selector muestra su propio aviso, sin toast.
                const companies = data.info || [];
                this.processTree(companies);
                return companies;
            })
            .catch(ex => {
                console.log(ex);
                toast.error("Error al consultar las companías");
                return null;
            });
    },
    /**
     * Empresas vencidas del usuario en sesión, para el diálogo "Suscripción vencida".
     * @returns {Promise<{companies: Array, hasActiveCompanies: boolean}|null>} null si la consulta falló
     */
    getExpired() {
        return http
            .get(entityRoute.GET_EXPIRED_COMPANIES)
            .then(({data}) => (data.code < 0 ? null : data.info))
            .catch(ex => {
                console.log(ex);
                return null;
            });
    },
    listCompanies() {
        let newInfo = [];
        return new Promise(resolve => {
            http
                .get(entityRoute.GET_COMPANIES_TREE)
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron compañías");
                        return;
                    }
                    if (code < 0) {
                        toast.error("Error al consultar las companías");
                        return;
                    }
                    const companiesList = data.info;
                    this.processTree(companiesList);
                    newInfo = companiesList;
                })
                .catch(ex => {
                    console.log(ex);
                    toast.error("Error al consultar las companías");
                })
                .finally(() => resolve(newInfo));
        });
    },
    processTree(companies) {
        for (let index = 0; index < companies.length; index++) {
            let company = companies[index];
            company.label = company.title ? company.title : company.name;
            company.id = company.code;
            if (company.children) {
                this.processTree(company.children);
            }
        }
    }
};